module.exports = __WEBPACK_EXTERNAL_MODULE__21947__;